import type { SVGProps } from 'react';
const SvgSportsCricket = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#sports_cricket_svg__a)">
      <path d="M15.05 12.81 6.56 4.32a.996.996 0 0 0-1.41 0L2.32 7.15a.996.996 0 0 0 0 1.41l8.49 8.49c.39.39 1.02.39 1.41 0l2.83-2.83a.996.996 0 0 0 0-1.41ZM15.755 16.342l-1.414 1.414L18.584 22l1.414-1.414-4.243-4.243ZM18.5 9a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" />
    </g>
    <defs>
      <clipPath id="sports_cricket_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSportsCricket;
